import { Link } from 'react-router-dom';
import { GYAKORLO_MODULE_IDS } from '../../config/gyakorlo';

/* A döntési gyakorló linkje a 13. és a 14. modul kártyája alatt (zárt modulnál
   is: a gyakorló 3 helyzete FREE-nek is nyitva). Más modulnál semmit nem rajzol. */
export default function GyakorloLink({ moduleId }) {
  if (!GYAKORLO_MODULE_IDS.includes(moduleId)) return null;
  return (
    <Link to="/gyakorlo" style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginTop: 10,
      padding: '10px 12px', borderRadius: 10, textDecoration: 'none',
      background: 'rgba(0,210,200,0.06)', border: '0.5px solid rgba(0,210,200,0.3)',
    }}>
      <span style={{ minWidth: 0 }}>
        <span style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#fff' }}>🎯 Döntési gyakorló</span>
        <span style={{ display: 'block', fontSize: 11, color: 'rgba(255,255,255,0.5)', marginTop: 2 }}>Valós BTC-helyzetek: előbb te döntesz, aztán lejátssza, mi történt.</span>
      </span>
      <span style={{ color: '#00D2C8', fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap' }}>Kipróbálom →</span>
    </Link>
  );
}
